import noop from 'lodash/noop';

import { useTranslation } from '@lyearn/i18n';
import UserSurveyRichTextInput from '@/modules/user-survey/questions/components/UserSurveyRichTextInput';
import { QuestionEntityEditorProps } from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/types';
import { QuestionTextlengthEnum } from '@/types/schema';

const TextEditor: React.FC<QuestionEntityEditorProps> = ({ allowAttachments, question }) => {
  const { t } = useTranslation();
  const multiline = question.settings?.textLength === QuestionTextlengthEnum.Long;

  return (
    <UserSurveyRichTextInput
      disabled
      allowAttachments={allowAttachments}
      multiline={multiline}
      placeholder={t('UserSurvey:LearnerDetails.TextQuestionPlaceholder')}
      onChangeText={noop}
    />
  );
};

export default TextEditor;
